import React, { useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";
import { Route, Routes } from "react-router-dom";
import {
  AddIcon,
  DownloadIcon
  // ManPowerIcon,
  // StarIcon
  // ClockCardIcon,
  // LocationCardIcon,
  // ReviewCardIcon
} from "../../Assets/assets";
import BreadCrumbs from "../../Components/BreadCrumbs/BreadCrumbs";
import Button from "../../Components/Button/Button";
// import { GraphCard, InfoCard, LegendCard } from "../../Components/Cards/Cards";
import CreateWorkforce from "../../Components/CreateWorkforce/CreateWorkforce";
import MultipleSelect from "../../Components/Filters/MultipleSelect";
// import { DoughnutChart } from "../../Components/Graphs/DoughnutChart";
// import LineChart from "../../Components/Graphs/LineChart";
import {
  GraphCard,
  //  GraphCard,
  LegendCard
  // LegendCard
} from "../../Components/Cards/Cards";
import DateRange from "../../Components/Filters/DateRange";
// import { DoughnutChart } from "../../Components/Graphs/DoughnutChart";
import WorkforcePreview from "../../Components/Previews/WorkforcePreview";
import WorkforceSummaryPreview from "../../Components/Previews/WorkforceSummaryPreview";
import SearchBox from "../../Components/SearchBox/SearchBox";
import Table from "../../Components/Table/Table";
import { useResizeObserver } from "../../CustomHooks/useResizeObserver";
import { setErrorStatus } from "../../Redux/status/action";
import {
  approveCapturePicture,
  deleteReferencePicture,
  getReferencePictureAsset,
  getSelectedEmployeeCapture,
  getSelectedEmployeeCaptureAssets,
  getSelectedEmployeePendingCaptures
} from "../../Redux/surveillance/action";
import {
  setSelectedTableData,
  setTableFilter,
  setTableSearchKey,
  setTableSort
} from "../../Redux/table/action";
import {
  archiveEmployee,
  assignLocations,
  unarchiveEmployee,
  createEmployee,
  editEmployee,
  updateProceduresToWorkforce
} from "../../Redux/workforce/action";
import { isValidArray, isValidObject } from "../../Services/validators";
import {
  FilterSeparator,
  generateColorMap,
  isFilterApplied
} from "../../Utils/Constants/Constants";
import {
  convertWorkforceToTableData,
  defaultWorkforceFilter,
  workforceFilterData,
  workforceTableField,
  workforceTableHeadings
} from "../../Utils/Constants/Workforce";
import { DoughnutChart } from "../../Components/Graphs/DoughnutChart";

export const Workforce = (props) => {
  const [selectedFilters, setSelectedFilters] = useState(
    defaultWorkforceFilter
  );
  const [collapse, setCollapse] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const filterContainerRef = useRef(null);
  const tableContainerRef = useRef(null);
  const { height } = useResizeObserver(filterContainerRef);
  const [isResetSingleKey, setIsResetSingleKey] = useState(false);

  useEffect(() => {
    if (!isResetSingleKey) {
      setSelectedFilters(props.table.workforce.filter);
    }
  }, [props.table.workforce.filter, isResetSingleKey]);

  useEffect(() => {
    if (props.table.workforce.searchKey) {
      setSearchKey(props.table.workforce.searchKey);
    }
    // eslint-disable-next-line
  }, []);

  const handleApplyClick = () => {
    props.setTableFilter("WORKFORCE", selectedFilters);
  };

  const handleResetClick = (key) => {
    setIsResetSingleKey(true);
    setSelectedFilters({
      ...selectedFilters,
      [key]: defaultWorkforceFilter[key]
    });
    props.setTableFilter("WORKFORCE", {
      ...props.table.workforce.filter,
      [key]: defaultWorkforceFilter[key]
    });
  };

  const referencePictureData = useMemo(() => {
    return isValidObject(props.surveillance.reference)
      ? Object.values(props.surveillance.reference).find(
          (data) =>
            data.employee?.id === props.table.workforce?.selectedEmployee
        )
      : {};
  }, [props.surveillance.reference, props.table.workforce.selectedEmployee]);

  const shouldShowEnterIcon = useMemo(() => {
    if (searchKey.length === 0) {
      return false;
    }

    if (props.table.workforce.searchKey === searchKey) {
      return false;
    }

    if (searchKey.length >= 3) {
      return true;
    }

    return false;
  }, [searchKey, props.table.workforce.searchKey]);

  const shouldShowCloseIcon = useMemo(() => {
    if (searchKey.length === 0) {
      return false;
    }

    if (props.table.workforce.searchKey === searchKey) {
      return true;
    }

    return false;
  }, [searchKey, props.table.workforce.searchKey]);

  const handleClearClick = () => {
    props.setTableFilter("WORKFORCE", defaultWorkforceFilter);
    setSelectedFilters(defaultWorkforceFilter);
    props.setTableSearchKey("WORKFORCE", "");
    setSearchKey("");
  };

  // const InfoCardData = [
  //   {
  //     icon: <ManPowerIcon />,
  //     title: "MANPOWER",
  //     value: (
  //       <div className="display-flex">
  //         <div
  //           style={{ fontSize: "40px" }}
  //           className="padding-right-default font-color-tertiaryColor"
  //         >
  //           {props.workforce.workforceSummary?.find(
  //             (data) => data.title === "JANITOR BASED ATTENDANCE"
  //           )?.count?.totalPresent || 0}
  //         </div>
  //         <div
  //           style={{ color: "var(--secondaryColor)", fontSize: "16px" }}
  //           className="padding-top-larger"
  //         >
  //           JANITORS
  //         </div>
  //       </div>
  //     )
  //   },
  //   {
  //     icon: <ManPowerIcon />,
  //     title: "MANPOWER",
  //     value: (
  //       <div className="display-flex">
  //         <div
  //           style={{ fontSize: "40px" }}
  //           className="padding-right-default font-color-tertiaryColor"
  //         >
  //           {props.workforce.workforceSummary?.find(
  //             (data) => data.title === "SUPERVISOR BASED ATTENDANCE"
  //           )?.count?.totalPresent || 0}
  //         </div>
  //         <div
  //           style={{ color: "var(--secondaryColor)", fontSize: "16px" }}
  //           className="padding-top-larger"
  //         >
  //           SUPERVISORS
  //         </div>
  //       </div>
  //     )
  //   },
  //   {
  //     icon: <StarIcon />,
  //     title: "MANPOWER",
  //     value: (
  //       <div className="display-flex">
  //         <div
  //           style={{ fontSize: "40px" }}
  //           className="padding-right-default font-color-tertiaryColor"
  //         >
  //           {props.workforce.workforceSummary?.find(
  //             (data) => data.title === "TOTAL WORKFORCE ATTENDANCE"
  //           )?.count?.totalPresent || 0}
  //         </div>
  //         <div
  //           style={{ color: "var(--secondaryColor)", fontSize: "16px" }}
  //           className="padding-top-larger"
  //         >
  //           EMPLOYEES
  //         </div>
  //       </div>
  //     )
  //   }
  // ];

  return (
    <>
      <Routes>
        <Route
          path="/:employeeId"
          element={
            <WorkforcePreview
              navigate={props.navigate}
              claims={props.claims}
              setErrorStatus={props.setErrorStatus}
              roles={props.workforce.roles}
              reference={props.surveillance.reference}
              forceReferencePictureUpdate={props.surveillance.forceReferencePictureUpdate}
              data={
                props.workforce.data?.[
                  props.table.workforce.selectedEmployee
                ] ||
                props.workforce.archivedData?.[
                  props.table.workforce.selectedEmployee
                ]
              }
              workforceData = { props.workforce.data }
              surveillanceLoading={props.surveillance.loading}
              pictureApprovalLoading={props.surveillance.pictureApprovalLoading}
              referencePictureData={referencePictureData}
              pendingCaptures={
                isValidObject(
                  props.surveillance.pendingCaptures?.[
                    props.table.workforce?.selectedEmployee
                  ]
                )
                  ? Object.values(
                      props.surveillance.pendingCaptures?.[
                        props.table.workforce?.selectedEmployee
                      ]
                    )
                  : []
              }
              capturePictureData={
                props.table.workforce.selectedEmployee &&
                isValidObject(
                  props.surveillance.captures?.[
                    props.table.workforce.selectedEmployee
                  ]
                )
                  ? Object.values(
                      props.surveillance.captures?.[
                        props.table.workforce.selectedEmployee
                      ]
                    )
                  : []
              }
              updateEmployeeData={(data) => {
                props.editEmployee(data);
              }}
              archiveEmployee={props.archiveEmployee}
              unarchiveEmployee={props.unarchiveEmployee}
              getSelectedEmployeeCapture={(data) => {
                props.getSelectedEmployeeCapture(data);
                props.getSelectedEmployeePendingCaptures(data);
              }}
              getReferencePictureAsset={(data) =>
                props.getReferencePictureAsset(data)
              }
              filterData={props.table.workforce.captureFilter}
              setTableFilter={props.setTableFilter}
              getSelectedEmployeeCaptureAssets={
                props.getSelectedEmployeeCaptureAssets
              }
              approveCapturePicture={props.approveCapturePicture}
              deleteReferencePicture={props.deleteReferencePicture}
              locationData={props.locations.data}
              procedures={props.procedures}
              assignLocations={props.assignLocations}
              updateProcedures={props.updateProcedures}
            />
          }
        />
        <Route
          path="/summary"
          element={
            <WorkforceSummaryPreview
              appliedFilters={props.table.workforce.filter}
              navigate={props.navigate}
              summaryDownloadClick={props.getWorkforceSummary}
              exportLoading={props.workforceLoading.export}
            />
          }
        />
        {props.claims?.employees?.create === true ? (
          <Route
            path="/create"
            element={
              <CreateWorkforce
                navigate={props.navigate}
                setErrorStatus={props.setErrorStatus}
                roles={props.workforce.roles}
                createNewEmployee={(data, file) => {
                  props.createEmployee(data, file);
                }}
                workforceData={props.workforce.data || {}}
              />
            }
          />
        ) : (
          []
        )}
      </Routes>
      <div
        className="inherit-parent-height inherit-parent-width position-relative overflow-hidden"
        ref={tableContainerRef}
      >
        <div className="inherit-parent-width">
          <div className="display-flex flex-justify-content-space-between flex-align-items-center">
            <BreadCrumbs />
            <div className="display-flex">
              {props.claims?.employees?.create === true ? (
                <div className="padding-right-default">
                  <Button
                    text="New Employee"
                    data-cy="CREATE-NEW-WORKFORCE-BUTTON"
                    boxShadow={false}
                    icon={
                      <AddIcon
                        color={
                          props.auth.theme.primaryColor === "#0E0E0E"
                            ? "#0E0E0E"
                            : "#FFFFFF"
                        }
                      />
                    }
                    onClick={() => {
                      props.navigate("/workforce/create");
                    }}
                    className="width-fit-content padding-left-large padding-right-large"
                  />
                </div>
              ) : (
                <></>
              )}
              <div>
                <Button
                  variant="transparent"
                  text="Download summary"
                  boxShadow={false}
                  icon={
                    props.workforceLoading.export ? (
                      <div
                        className="qr-loader"
                        style={{ height: "16px", width: "16px" }}
                      />
                    ) : (
                      <DownloadIcon color="var(--tertiaryColor6)" />
                    )
                  }
                  onClick={() => {
                    props.navigate("/workforce/summary");
                  }}
                  className="width-fit-content padding-left-large padding-right-large"
                />
              </div>
            </div>
          </div>

          <div
            ref={filterContainerRef}
            className="padding-top-larger display-flex flex-justify-content-space-between"
          >
            <div
              style={{ width: "90%", flexWrap: "wrap", gap: "8px" }}
              className="display-flex flex-align-items-center"
            >
              <div style={{ width: "200px" }}>
                <SearchBox
                  title="SEARCH WORKFORCE"
                  placeHolder="SEARCH WORKFORCE"
                  value={searchKey}
                  onChange={(event) => {
                    if (event.target.value.length > 0) {
                      setSearchKey(event.target.value);
                    } else {
                      setSearchKey("");
                      props.setTableSearchKey("WORKFORCE", "");
                    }
                  }}
                  showEnterIcon={shouldShowEnterIcon}
                  enterOnClick={() => {
                    props.setTableSearchKey("WORKFORCE", searchKey);
                  }}
                  showCloseIcon={shouldShowCloseIcon}
                  closeOnClick={() => {
                    setSearchKey("");
                    props.setTableSearchKey("WORKFORCE", "");
                  }}
                />
              </div>
              <div className="display-flex flex-align-items-center position-relative">
                <FilterSeparator />
                <DateRange
                  loading={props.workforce.loading}
                  data-cy="DATE RANGE"
                  data={
                    workforceFilterData(
                      props.locations.data,
                      props.workforce.roles
                    )[0]
                  }
                  onResetClick={(key) => {
                    handleResetClick(key);
                  }}
                  setSelectedFilters={setSelectedFilters}
                  selectedFilters={selectedFilters}
                  appliedFilters={props.table.workforce.filter}
                  selected={selectedFilters["dateRange"]}
                />
                <FilterSeparator />

                <MultipleSelect
                  loading={props.workforce.loading}
                  data-cy="ROLE-MULTI"
                  data={
                    workforceFilterData(
                      props.locations.data,
                      props.workforce.roles
                    )[1]
                  }
                  onResetClick={(key) => {
                    handleResetClick(key);
                  }}
                  setSelectedFilters={setSelectedFilters}
                  selectedFilters={selectedFilters}
                  appliedFilters={props.table.workforce.filter}
                  selected={selectedFilters["role"]}
                />

                <FilterSeparator />

                {/* <MultipleSelect
                  loading={props.workforce.loading}
                  data-cy="ASSIGNED-LOCATIONS-MULTI"
                  data={
                    workforceFilterData(
                      props.locations.data,
                      props.workforce.roles
                    )[2]
                  }
                  onResetClick={(key) => {
                    handleResetClick(key);
                  }}
                  setSelectedFilters={setSelectedFilters}
                  selectedFilters={selectedFilters}
                  appliedFilters={props.table.workforce.filter}
                  selected={selectedFilters["assignedLocations"]}
                />

                <FilterSeparator /> */}

                <MultipleSelect
                  loading={props.workforce.loading}
                  data-cy="ROLE-MULTI"
                  data={
                    workforceFilterData(
                      props.locations.data,
                      props.workforce.roles
                    )[2]
                  }
                  onResetClick={(key) => {
                    handleResetClick(key);
                  }}
                  setSelectedFilters={setSelectedFilters}
                  selectedFilters={selectedFilters}
                  appliedFilters={props.table.workforce.filter}
                  selected={selectedFilters["captureApproval"]}
                />

                <FilterSeparator />

                <MultipleSelect
                  loading={props.workforce.loading}
                  data-cy="STATUS-MULTI"
                  data={
                    workforceFilterData(
                      props.locations.data,
                      props.workforce.roles
                    )[3]
                  }
                  onResetClick={(key) => {
                    handleResetClick(key);
                  }}
                  setSelectedFilters={setSelectedFilters}
                  selectedFilters={selectedFilters}
                  appliedFilters={props.table.workforce.filter}
                  selected={selectedFilters["status"]}
                />
              </div>
            </div>

            {isFilterApplied(selectedFilters, "WORKFORCE").validation && (
              <div
                style={{
                  width: "10%"
                }}
                className={`display-flex flex-justify-content-space-between`}
              >
                <div
                  style={{
                    width: "60%"
                  }}
                >
                  <Button
                    data-cy="FILTER-APPLY-BUTTON"
                    text="Apply"
                    boxShadow={false}
                    variant="filter"
                    loading={props.loading}
                    className="inherit-parent-width padding-left-large padding-right-large"
                    onClick={() => {
                      handleApplyClick();
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "40%"
                  }}
                >
                  <Button
                    data-cy="FILTER-RESET-BUTTON"
                    variant="transparent"
                    text="Clear"
                    boxShadow={false}
                    className="inherit-parent-width padding-left-large padding-right-large"
                    onClick={() => {
                      props.setTableFilter("WORKFORCE", defaultWorkforceFilter);
                      setSelectedFilters(defaultWorkforceFilter);
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <div
          style={{
            height: `calc(100% - ${height + 32}px`
          }}
        >
          {!collapse && (
            <>
              {/* <div className="display-flex flex-justify-content-space-between margin-top-larger">
                {InfoCardData.map((data, index) => (
                  <React.Fragment key={index}>
                    <InfoCard data={data} />
                  </React.Fragment>
                ))}
              </div> */}
              <div
                className="display-flex flex-justify-content-space-between padding-top-larger flex-wrap overflow-scroll"
                style={{ maxHeight: "300px" }}
              >
                {isValidArray(props.workforce.workforceSummary) &&
                  props.workforce.workforceSummary?.map((summary, i) => (
                    <React.Fragment key={i}>
                      <GraphCard
                        title={summary.title}
                        theme={
                          props.auth.theme.primaryColor === "#0E0E0E"
                            ? "dark"
                            : "light"
                        }
                        graph={
                          <DoughnutChart
                            // disableCustomToolTip={true}
                            data={getAttendanceChartData(
                              summary.title,
                              summary.count
                            )}
                          />
                        }
                        legend={
                          <div
                            style={{
                              height: "180px",
                              overflowY: "scroll"
                            }}
                            className="display-flex flex-justify-content-center hide-scrollbar flex-direction-column padding-right-larger"
                          >
                            {getAttendanceChartData(
                              summary.title,
                              summary.count
                            ).datasets[0].backgroundColor.map((data, i) => (
                              <div key={i}>
                                <LegendCard
                                  data={getAttendanceChartData(
                                    summary.title,
                                    summary.count
                                  )}
                                  count={true}
                                  color={data}
                                  index={i}
                                />
                              </div>
                            ))}
                          </div>
                        }
                      />
                    </React.Fragment>
                  ))}
              </div>
            </>
          )}

          {height && (
            <div
              style={{
                height: `calc(100% - ${collapse ? 0 : 420}px`
              }}
              className="padding-top-larger"
            >
              <Table
                theme={
                  props.auth.theme.primaryColor === "#0E0E0E" ? "dark" : "light"
                }
                title="ALL WORKFORCE"
                setCollapse={(data) => {
                  setCollapse(data);
                  if (tableContainerRef.current) {
                    tableContainerRef.current.scrollTop = 0;
                  }
                }}
                disableSorting={
                  props.table.workforce.searchKey.length > 0 ? true : false
                }
                allowCollapse={true}
                collapse={collapse}
                headers={workforceTableHeadings}
                onClick={(data) => {
                  props.setSelectedTableData("WORKFORCE", data.documentId);
                  props.navigate(`workforce/${data.documentId}`);
                }}
                data={
                  isValidArray(props.workforce.results)
                    ? convertWorkforceToTableData(
                        props.workforce.results,
                        props.workforce.roles
                      ).slice(0, !collapse ? 24 : 50)
                    : []
                }
                getField={workforceTableField}
                totalPage={Math.ceil(props.workforce.total / 50)}
                currentPage={props.table.workforce.pageNumber}
                previousPageOnClick={() => {
                  props.getWorkforcePreviousPage();
                }}
                nextPageOnClick={() => {
                  props.getWorkforceNextPage();
                }}
                resetAllClick={() => {
                  handleClearClick();
                }}
                sort={props.table.workforce.sort}
                handleSort={(title) => {
                  if (props.table.workforce.searchKey.length > 0) {
                    return;
                  }
                  props.setTableSort("WORKFORCE", {
                    title: title,
                    ascending:
                      props.table?.workforce?.sort?.title === title
                        ? !props.table?.workforce?.sort?.ascending
                        : true
                  });
                }}
                backgroundColor="background-color-primary"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = function(state) {
  return {
    locations: state.locations,
    auth: state.auth,
    surveillance: state.surveillance,
    table: state.table,
    workforce: state.workforce,
    procedures: state.procedures.data
  };
};

const mapDispatchToProps = function() {
  return {
    setSelectedTableData: (tableName, data) =>
      setSelectedTableData(tableName, data),
    getSelectedEmployeeCapture: (documentId) =>
      getSelectedEmployeeCapture(documentId),
    getSelectedEmployeePendingCaptures: (documentId) =>
      getSelectedEmployeePendingCaptures(documentId),
    getSelectedEmployeeCaptureAssets: (currentPage, documentId) =>
      getSelectedEmployeeCaptureAssets(currentPage, documentId),
    getReferencePictureAsset: (documentId) =>
      getReferencePictureAsset(documentId),
    editEmployee: (data) => editEmployee(data),
    archiveEmployee: (documentId) => archiveEmployee(documentId),
    unarchiveEmployee: (documentId) => unarchiveEmployee(documentId),
    setTableFilter: (tableName, data) => setTableFilter(tableName, data),
    setTableSort: (tableName, data) => setTableSort(tableName, data),
    setTableSearchKey: (tableName, value) =>
      setTableSearchKey(tableName, value),
    createEmployee: (data, file) => createEmployee(data, file),
    setErrorStatus: (error) => setErrorStatus(error),
    approveCapturePicture: (data) => approveCapturePicture(data),
    deleteReferencePicture: (documentId) => deleteReferencePicture(documentId),
    assignLocations: (employeeId, locations) =>
      assignLocations(employeeId, locations),
    updateProcedures: (employeeId, procedures) =>
      updateProceduresToWorkforce(employeeId, procedures)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Workforce);

export const getAttendanceChartData = (title, count) => {
  if (!isValidObject(count)) {
    return {
      labels: [],
      datasets: [
        {
          label: "Shifts",
          data: [],
          backgroundColor: [],
          borderColor: [],
          borderWidth: 2,
          borderRadius: 0,
          spacing: 2
        }
      ],
      defaultValue: {
        label: "TOTAL",
        value: 0
      }
    };
  }

  const backgroundColor = [];
  const borderColor = [];

  Object.values(count).forEach((_value, index) => {
    const color = generateColorMap()[index] || generateColorMap().default;
    backgroundColor.push(color.bg);
    borderColor.push(color.border);
  });

  return {
    labels: Object.keys(count),
    datasets: [
      {
        label: title,
        data: Object.values(count),
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderWidth: 2,
        borderRadius: 0,
        spacing: 2
      }
    ],
    defaultValue: {
      label: "TOTAL",
      value: Object.values(count).reduce((sum, value) => sum + value, 0)
    }
  };
};
